// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SectionOrderCommunications_wrapper__3x6ak","greenBackground":"SectionOrderCommunications_greenBackground__3f_R1"};